import React, { useState } from "react";
import PropTypes from "prop-types";
import TextInput from "../common/TextInput";
import SelectInput from "../common/SelectInput";
import PageTitle from "../common/PageTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RecipeTagSelector } from "./RecipeFormTagSelector";
import { RecipeAdminList } from "./RecipeAdminList";

import {
  faPlusSquare,
  faMinusSquare,
  faSortUp,
  faSortDown,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons";

const RecipeForm = ({
  formActions,
  recipe,
  recipeOptions,
  steps = [],
  ingredients = [],
  admin = [],
  errors = {},
  userId = "",
}) => {
  const toggleRecipeOption = (e) => {
    formActions.handleRecipeChange(e);
  };

  const [view, toggleView] = useState("recipe");

  return (
    <>
      {recipe._id ? <PageTitle title={recipe.title} /> : null}
      <hr />
      {view === "recipe" ? (
        <form onSubmit={formActions.handleSaveRecipe}>
          {recipe._id ? null : (
            <>
              <div className="form-group">
                <br />
                <TextInput
                  name="title"
                  label="Title"
                  value={recipe.title || ""}
                  onChange={formActions.handleRecipeChange}
                  error={errors.title}
                />
              </div>
              <hr />
            </>
          )}
          <div className="form-group">
            <div className="d-flex justify-content-between">
              <label>
                Is public:
                <input
                  name="public"
                  type="checkbox"
                  checked={recipe.public || false}
                  onChange={formActions.handleRecipeChange}
                />
              </label>
              <p
                onClick={() =>
                  view === "recipe"
                    ? toggleView("sharedAccess")
                    : toggleView("recipe")
                }
              >
                shared access
              </p>
            </div>
          </div>

          <hr />
          <div className="form-group">
            <div className="d-flex justify-content-between">
              <label htmlFor="ingredients">Ingredients:</label>
              <p>
                Add Ingredient{" "}
                <FontAwesomeIcon
                  icon={faPlusSquare}
                  onClick={formActions.addIngredient}
                />
              </p>
            </div>
            <br />
            {ingredients.map((ingredient, idx) => {
              return (
                <div key={idx} className="d-flex justify-content-between">
                  <div className="form-group row" style={{ width: "100%" }}>
                    <div className="col">
                      <TextInput
                        label=""
                        name={`ingredient_${ingredient.number}_name`}
                        value={ingredient.ingredient}
                        onChange={formActions.handleRecipeChange}
                        placeholder="Ingredient Name"
                      />
                    </div>
                    <div className="col">
                      <TextInput
                        label=""
                        name={`ingredient_${ingredient.number}_measure`}
                        value={ingredient.measurement}
                        onChange={formActions.handleRecipeChange}
                        placeholder="2 Tablespoons"
                      />
                    </div>
                  </div>
                  <p>
                    {" "}
                    <FontAwesomeIcon
                      icon={faMinusSquare}
                      onClick={() => formActions.deleteIngredient(ingredient)}
                    />
                  </p>
                </div>
              );
            })}
            {errors.ingredients ? (
              <div className="alert alert-danger">{errors.ingredients}</div>
            ) : (
              ""
            )}
          </div>
          <hr />
          <div className="form-group">
            <div className="d-flex justify-content-between">
              <label htmlFor="steps">Recipe steps:</label>
              <p>
                Add Step{" "}
                <FontAwesomeIcon
                  icon={faPlusSquare}
                  onClick={formActions.addStep}
                />
              </p>
            </div>

            <br />
            {steps.map((step) => {
              return (
                <div key={step.number} className="form-group row">
                  <div className="col">
                    <label htmlFor={step.number}>Step {step.number}</label>
                    <div className="d-flex justify-content-between">
                      <textarea
                        key={step.number}
                        name={`step_${step.number}`}
                        value={step.value}
                        className="form-control"
                        rows="2"
                        onChange={formActions.handleRecipeChange}
                        style={{ width: "97%" }}
                      ></textarea>
                      <div>
                        <p>
                          {" "}
                          <FontAwesomeIcon
                            icon={faMinusSquare}
                            onClick={() => formActions.deleteStep(step)}
                          />
                        </p>
                        {step.number > 1 && (
                          <p>
                            {" "}
                            <FontAwesomeIcon
                              icon={faSortUp}
                              onClick={() => formActions.sort(step, "up")}
                            />
                          </p>
                        )}

                        {step.number < steps.length && (
                          <p>
                            {" "}
                            <FontAwesomeIcon
                              icon={faSortDown}
                              onClick={() => formActions.sort(step, "down")}
                            />
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {errors.steps ? (
              <div className="alert alert-danger">{errors.steps}</div>
            ) : (
              ""
            )}
          </div>
          <hr />
          <div className="form-group">
            <label htmlFor="notes">Notes: </label>
            <textarea
              name="notes"
              value={recipe.notes || ""}
              className="form-control"
              rows="2"
              onChange={formActions.handleRecipeChange}
            ></textarea>
          </div>
          <hr />
          <div className="form-group row">
            <div className="d-flex justify-content-between">
              <div className="col">
                <TextInput
                  label="Prep Time"
                  name="prepTime"
                  value={recipe.prepTime || ""}
                  onChange={formActions.handleRecipeChange}
                  placeholder="45 minutes"
                />
              </div>

              <div className="col">
                <TextInput
                  label="Cook Time"
                  name="cookTime"
                  value={recipe.cookTime || ""}
                  onChange={formActions.handleRecipeChange}
                  placeholder="20 minutes"
                />
              </div>
            </div>
          </div>
          <hr />
          <SelectInput
            name="difficulty"
            label="Difficulty"
            value={recipe.difficulty || ""}
            defaultOption="Select Difficulty Level"
            options={["easy", "medium", "hard"].map((level) => ({
              value: level,
              text: level,
            }))}
            onChange={formActions.setDifficulty}
          />
          <div className="form-group">
            <RecipeTagSelector
              options={recipeOptions}
              clickOption={toggleRecipeOption}
            />
          </div>
          <div className="d-flex justify-content-between">
            <button type="submit" className="btn btn-primary">
              {recipe._id ? "Update Recipe" : "Add Recipe"}
            </button>
            {recipe._id ? (
              <button
                className="btn btn-danger"
                onClick={formActions.handleDelete}
              >
                Delete Recipe
              </button>
            ) : null}
          </div>
        </form>
      ) : (
        <div>
          <p style={{ fontSize: "20px" }} onClick={() => toggleView("recipe")}>
            {" "}
            <FontAwesomeIcon icon={faLongArrowAltLeft} />
            <span> back</span>
          </p>
          {/* <div className="sharedWithList">List...</div> */}
          <RecipeAdminList
            list={admin && recipe.recipeAdminMap ? recipe.recipeAdminMap : []}
            handleSearch={formActions.handleSearch}
            recipe={recipe._id}
          />
        </div>
      )}
    </>
  );
};

RecipeForm.propTypes = {
  formActions: PropTypes.object.isRequired,
  steps: PropTypes.array.isRequired,
  ingredients: PropTypes.array.isRequired,
  recipe: PropTypes.object.isRequired,
  errors: PropTypes.object,
  isPublic: PropTypes.bool,
};

export default RecipeForm;
